import countries from "iso-3166-country-list";

export function normalizeCountryCode(value) {
  const raw = String(value ?? "DE").trim().toUpperCase();
  return raw.length === 2 ? raw : "DE";
}

export function getCountryLabel(code, t, i18n) {
  const c = normalizeCountryCode(code);
  if (i18n.language === "en") {
    return countries.find((entry) => entry.code === c)?.name || c;
  }
  return t(`country.${c}`, c);
}

export function getCountryOptions(t, i18n) {
  return countries.map(({ code, name }) => ({
    code,
    name: i18n.language === "en" ? name : t(`country.${code}`, name),
  }));
}
